import { render, staticRenderFns } from "./newquotation.vue?vue&type=template&id=457dd66b"
import script from "./newquotation.vue?vue&type=script&lang=js"
export * from "./newquotation.vue?vue&type=script&lang=js"
import style0 from "./newquotation.vue?vue&type=style&index=0&id=457dd66b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports